import * as consts from './ModalsConsts';

const initialState = {
    modalShareIsOpen: false,
    modalDraftIsOpen: false,
    modalDisclaimerIsOpen: false,
    emailSent: false
};

const modals = (state = initialState, action) => {
    switch (action.type) {
        case consts.CHANGE_MODAL_VISIBILITY:
            return {
                ...state,
                [action.payload.name]: action.payload.value,
                emailSent: false
            }
        case consts.SEND_EMAIL_FULFILLED:
            return {
                ...state,
                emailSent: true
            }
        default:
            return state
    }
}

export default modals;
